export type MenuItem = {
  name: string;
  description: string;
  price: string;
};

export type MenuCategory = {
  id: string;
  label: string;
  items: MenuItem[];
};

export const signatureDishes = [
  {
    name: 'Poitrine de porc confite',
    note: 'Purée de butternut, piments grillés, pesto d’herbes',
    image: 'https://cdn.magicpatterns.com/uploads/iAihdEaxsY7bXbG6xx8UsJ/unnamed_(1).webp',
  },
  {
    name: 'Vitello tonnato',
    note: 'Câpres frites, chapelure dorée, piment d’Espelette',
    image: 'https://cdn.magicpatterns.com/uploads/65EKXtBR9rsWs4u9u2Ckxn/unnamed_(2).webp',
  },
  {
    name: 'Betteraves & radis',
    note: 'Crème fraîche fumée, huile verte, jeunes pousses',
    image: 'https://cdn.magicpatterns.com/uploads/mReti52Awi9MtZMhyC9udg/unnamed_(4).webp',
  },
];

export const menuCategories: MenuCategory[] = [
  {
    id: 'entrees',
    label: 'Entrées',
    items: [
      { name: 'Betteraves & radis du marché', description: 'Crème fumée, huile d’herbes, piment doux', price: '11 €' },
      { name: 'Vitello tonnato', description: 'Veau rosé, sauce thon, câpres frites', price: '13 €' },
      { name: 'Œuf parfait', description: 'Velouté de saison, croûtons, lard grillé', price: '10 €' },
      { name: 'Planche à partager', description: 'Charcuteries et fromages de la région', price: '18 €' },
    ],
  },
  {
    id: 'plats',
    label: 'Plats',
    items: [
      { name: 'Poitrine de porc confite', description: 'Butternut, piments grillés, pesto d’herbes', price: '22 €' },
      { name: 'Poisson de la criée', description: 'Selon arrivage, légumes de saison, beurre blanc', price: '24 €' },
      { name: 'Magret des Landes', description: 'Jus corsé, pommes grenaille, salade', price: '23 €' },
      { name: 'Assiette végétale', description: 'Légumes du moment, céréales, condiments maison', price: '18 €' },
    ],
  },
  {
    id: 'desserts',
    label: 'Desserts',
    items: [
      { name: 'Tarte fine aux fruits de saison', description: 'Crème crue, sablé breton', price: '9 €' },
      { name: 'Mousse au chocolat noir', description: 'Fleur de sel, huile d’olive', price: '8 €' },
      { name: 'Fromages affinés', description: 'Sélection du fromager, confiture maison', price: '10 €' },
    ],
  },
  {
    id: 'vins',
    label: 'Bar à vin',
    items: [
      { name: 'Vin du moment au verre', description: 'Blanc, rouge ou rosé — demandez la sélection', price: 'dès 5 €' },
      { name: 'Côtes de Gascogne', description: 'Blanc sec, vif et fruité', price: '26 € la bouteille' },
      { name: 'Madiran', description: 'Rouge charpenté du Sud-Ouest', price: '32 € la bouteille' },
      { name: 'Bières & softs artisanaux', description: 'Brasseries locales, jus de fruits', price: 'dès 4 €' },
    ],
  },
];
